import React, { Component } from 'react'
import { connect } from 'react-redux'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import LeftSide from './LeftSide'
import RightSide from './RightSide'
import Deleted from 'components/Deleted'
import Divider from 'material-ui/Divider'

import { doc, dirtyRead, bufferById } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		project: doc(state, props.id || props.routeParams.id)
	  , isEditing: !!bufferById(state, props.id || props.routeParams.id)
	  , mode: state.mode
	})
)

export class ProjectForm extends Component{
	render(){
		let { props } = this;
		let projectID = this.props.id || this.props.routeParams.id
		let countColomns = this.props.colspan || 2
		let widthColomns = (this.props.style && this.props.style.width && countColomns)?(this.props.style.width.split('px')[0]/countColomns)-18+"px":"50%"
		return(
			<div
				style={{
					display: "inline-block"
				  , width: "100%"
				  , overflow: "hidden"
				}}
			>
				<FormHeader
					title={(this.props.project && this.props.project.title)? this.props.project.title : this.props.isEditing && "New project"}
					statusIcon={<img src="/landlord/static/img/Projects_green.png"style={{width: "22px", display: "block", marginTop:"4px", marginLeft: "7px"}}/>}
					masterDetail={props.masterDetail || false}
					objectID= {projectID}
					commitDisabled={(this.props.mode == 'new' || this.props.mode == 'creating') && !(props.project.ownerID && props.project.propertyID && props.project.templateID)}
				/>
				{(!this.props.project)?
					<Deleted />
					:
					<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden"}}>
						{(this.props.mode == 'new' || this.props.mode == 'creating')?
							<Deleted />
							:
							<main style={{minHeight:"calc(100vh - 64px)", display:(countColomns>1)?"flex":"block"}}>
				  				<LeftSide projectID={projectID} countColomns={countColomns}/>
								{countColomns==1 && <Divider style={{marginTop: "20px"}}/>}
								<RightSide projectID={projectID} countColomns={countColomns}/>
							</main>
						}

						<div
							style={{
								position:"fixed"
						      , zIndex:"9999"
							  , bottom:"3px"
							  , right:"17px"
							  , boxSizing: "borderBox"
							  , maringRight: "17px"
							}}
						>
							<FormFooter objectID={projectID} masterDetail={this.props.masterDetail || false} commitDisabled={(this.props.mode == 'new' || this.props.mode == 'creating') && !(props.project.ownerID && props.project.propertyID && props.project.templateID)}/>
						</div>
					</div>
				}
			</div>
		)
	}
}

export default connect(select)(ProjectForm)



// WEBPACK FOOTER //
// ./src/routes/landlord/projectForm/index.js